import { render } from "./ListeMarque.vue?vue&type=template&id=54dd585d&ts=true"
import script from "./ListeMarque.vue?vue&type=script&lang=ts"
export * from "./ListeMarque.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__